module.exports = __webpack_public_path__ + "img/cost_icon_13.982bc872.svg";